import { Config } from "./helpers";

export async function fetchBanner(id, abortController) {
  const url = Config.Routing.model(id);

  const response = await fetch(url, { signal: abortController.signal });

  if (response.ok === false) {
    return [false, 'Failed to load banner'];
  }

  const json = await response.json();

  return [true, json];
}
